module.exports = __webpack_public_path__ + "static/media/conlicita-academy.49cd92e3.svg";